import React from 'react';
import { graphql, Link } from 'gatsby';
import Layout from '../components/Layout';
import PreviewCompatibleImage from '../components/PreviewCompatibleImage';
import { ContactForm } from '../views/contact-form';
import { GiftsShowcase } from '../views/gifts-showcase';
import { HTMLContent } from '../components/Content';

export const GiftPageTemplate = ({ title, price, discount_price, image, html, slug }) => (
  <section className="section">
    <div className="container">
      <h4 className="title is-4 has-text-centered">
        <Link to="/gifts">← Цветочные подарки</Link>
      </h4>
      <div className="content">
        <div className="columns">
          <div className="column">
            <PreviewCompatibleImage imageInfo={image} style={{ maxHeight: '480px' }} />
          </div>
          <div className="column">
            <h1 className="title is-1">{title}</h1>
            <HTMLContent content={html} />
            <h2>
              {discount_price ? (
                <span style={{ textDecoration: 'line-through', color: '#999', fontSize: '80%' }}>
                  {price}
                </span>
              ) : null}{' '}
              {discount_price ? discount_price : price} <small>рублей</small>
            </h2>
          </div>
        </div>
        <hr />
        <div className="columns">
          <div className="column is-half is-offset-one-quarter">
            <h2 className="has-text-centered">Заказать</h2>
            <ContactForm order title={title} slug={slug} />
          </div>
        </div>
        <h2 className="title is-2">Другие подарки</h2>
        <GiftsShowcase />
        <h4 className="title is-4 has-text-centered">
          <Link to="/gift">смотреть все подарки →</Link>
        </h4>
      </div>
    </div>
  </section>
);

export default ({ data }) => {
  const { frontmatter, html } = data.markdownRemark;

  return (
    <Layout title={frontmatter.title}>
      <GiftPageTemplate {...frontmatter} html={html} />
    </Layout>
  );
};

export const giftPageQuery = graphql`
  query GiftPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      ...GiftForPage
    }
  }
`;
